<template>
    <div class="content-wrapper-scroll">
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-header">
                            <h5>New Cluster</h5>
                        </div>
                        <div class="card-body">
                            <div class="field-wrapper">
                                <input class="form-control" type="text" :class="{'is-invalid': errors.cluster_name}" placeholder="Name" v-model="cluster.cluster_name" ref="cluster_name" />
                                <span v-if="errors.cluster_name" class="invalid-feedback">{{ errors.cluster_name[0] }}</span>
                                <div class="field-placeholder">Cluster Name <span class="text-danger">*</span></div>
                            </div>
                            <div class="field-wrapper">
                                <textarea class="form-control" rows="2" :class="{'is-invalid': errors.description}" placeholder="description" v-model="cluster.description" ref="description"></textarea>
                                <span v-if="errors.description" class="invalid-feedback">{{ errors.description[0] }}</span>
                                <div class="field-placeholder">Description</div>
                            </div>
                            <div class="form-actions-footer">
                                <div class="text-end">
                                    <button class="btn btn-danger" @click="reset">Discard</button>
                                    <button v-can="'categories.create'" class="btn btn-primary ms-1" v-if="status" @click="addCluster()">Submit</button>
                                    <button v-can="'categories.update'" class="btn btn-primary ms-1" v-else @click="updateCluster()">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-8">
                    <div class="card">
                        <div class="card-header">
                            <h5>Clusters</h5>
                        </div>
                        <div class="card-body">
                            <div class="col-sm-12">
                                <div class="input-group">
                                    <input class="form-control" type="text" placeholder="Type here and press enter to search" v-model="meta.search" @keyup.enter="search" />
                                    <span class="input-group-text">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>

                            <div class="table-responsive" style="margin-top: 10px;">
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>

                                            <th @click="sort('cluster_name')">
                                                Name
                                                <span>
                                                    <i v-if="meta.field=='cluster_name' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.field=='cluster_name' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th @click="sort('description')">
                                                Description
                                                <span>
                                                    <i v-if="meta.field=='description' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.field=='description' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="clusters.length==0">
                                            <td colspan="4" class="text-center">No records found</td>
                                        </tr>
                                        <tr></tr>
                                        <tr v-for="(cluster,key) in clusters" :key="cluster.cluster_id">
                                            <td>{{ meta.from+key }}</td>
                                            <td>{{cluster.cluster_name}}</td>
                                            <td>{{cluster.description}}</td>
                                            <td class="td-actions">
                                                <a href="#" v-can="'categories.update'" class="icon green" @click.prevent="edit(cluster)">
                                                    <i class="icon-pencil"></i>
                                                </a>
                                                <a href="#" v-can="'categories.delete'" class="icon red" @click.prevent="deleteCluster(cluster)">
                                                    <i class="icon-cancel"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="form-actions-footer">
                                <div class="text-end row">
                                    <div class="col-sm-2">
                                        <select class="form-control" v-model="meta.per_page" @change="onPerPageChange">
                                            <option>10</option>
                                            <option>15</option>
                                            <option>20</option>
                                            <option>25</option>
                                            <option>30</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-10">
                                        <Pagination class="pagination pagination-sm" :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.currentPage" @pagechanged="onPageChange" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: { Pagination },
        data() {
            return {
                status: true,
                clusters: [],
                cluster: {
                    cluster_id: "",
                    cluster_name: "",
                    description: "",
                },
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "cluster_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                },
                errors: [],
            };
        },
        mounted() {
            this.$refs.cluster_name.focus()
            this.index();
        },
        methods: {
            getClusters() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "getClusters" })
                    .then(function (response) {
                        vm.clusters = response.data;
                        vm.index();
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
                },
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginateClusters", data: vm.meta })
                    .then(function (response) {
                        vm.clusters = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addCluster();
                } else {
                    vm.updateCluster();
                }
            },
            addCluster() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addCluster", data: vm.cluster })
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Cluster Added successfully");
                        vm.index();
                        vm.discard();
                        vm.errors = [];
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            edit(cluster) {
                let vm = this;
                vm.errors = [];
                vm.status = false;
                vm.cluster = cluster;
                vm.$refs.cluster_name.focus();
            },
            updateCluster() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "updateCluster", data: vm.cluster };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Cluster is successfully updated");
                        vm.discard();
                        vm.errors = [];
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            deleteCluster(cluster) {
                if(confirm("Are you sure you want to delete cluster?")){
                    let vm = this;
                    cluster.status = cluster.status == 1 ? 0 : 1;
                    vm.$store
                        .dispatch("post", { uri: "deleteCluster", data: cluster })
                        .then(function () {
                            vm.discard();
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            },
            discard() {
                let vm = this;
                vm.cluster.cluster_id = "";
                vm.cluster.cluster_name = "";
                vm.cluster.description = "";
                vm.errors = [];
                vm.status = true;
                vm.$refs.cluster_name.focus()
                vm.index();
            },
            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
        },
    };
</script>
